var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-stage-cta-buttons",class:{
    'owc-stage-cta-buttons--dark': _vm.isDarkMode,
  }},[(_vm.shouldRenderSkeletons)?[_c('wb-skeleton',{staticStyle:{"width":"160px","height":"48px","margin-right":"0.5rem"},attrs:{"theme":"dark"}}),_c('wb-skeleton',{staticStyle:{"width":"144px","height":"48px"},attrs:{"theme":"dark"}})]:_vm._l((_vm.ctas),function(cta){return _c('a',{key:cta.label,staticClass:"owc-stage-cta-buttons__button wb-button wb-button--medium",class:[
      {
        'wb-button--theme-dark': _vm.isDarkMode,
        'wb-button--large': !_vm.isMobile,
      },
      _vm.getCtaButtonClasses(cta),
    ],attrs:{"target":cta.target,"href":cta.url}},[_vm._v(" "+_vm._s(cta.label)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }